// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://bepvbsfrhejbhfzkwxys.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJlcHZic2ZyaGVqYmhmemt3eHlzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE0NDAzMDEsImV4cCI6MjA4NzAxNjMwMX0.86NNbxEBPYSIVO-BSo3_EWGUbKiQdxohbW5kGJ0x354";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});